import { Circle } from "lucide-react";

const PHRASES = [
  "By design — not by policy",
  "Hash-based authentication",
  "No identity link",
  "Zero data retention",
  "Stateless inference",
  "Encrypted at rest, encrypted in motion",
  "Nothing to leak. Nothing to subpoena.",
];

function Row() {
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 56 }}>
      {PHRASES.map((p, i) => (
        <span key={i} style={{ display: "inline-flex", alignItems: "center", gap: 56 }}>
          <span>{p}</span>
          <Circle size={6} fill="var(--accent)" stroke="none" />
        </span>
      ))}
    </span>
  );
}

export default function Marquee() {
  return (
    <div className="marquee" aria-hidden="true">
      <div className="marquee-track">
        <Row /><Row />
      </div>
    </div>
  );
}
